import RoomPage from '../RoomPage';

const ProducerRoom = () => {
  return (
    <RoomPage
      roomName="Producer"
      roomTitle="企画プロデュース"
      description="大きなイベントより、小さな集まり。数より深さを大切にした企画プロデュース。「ここに来てよかった」と思える時間を一緒につくります。"
      heroGradient={{
        from: '#042F25',
        to: '#064034',
      }}
      works={[
        {
          title: '小規模イベント企画',
          description: '少人数で深く繋がる場づくり',
        },
        {
          title: 'ワークショップ設計',
          description: '学びと対話を大切にした体験設計',
        },
        {
          title: 'コミュニティ運営',
          description: '静かに続く、居心地のよい場所',
        },
        {
          title: '動画配信',
          description: 'チャンネルを立ち上げて、動画を配信します。',
        },
      ]}
    />
  );
};

export default ProducerRoom;